import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'accessoryFilter',
    pure: true,
})
export class AccessoryFilter implements PipeTransform {
    transform(items: any[]): any {
        if (!items) {
            return items
        }
        return items.filter(item => item.optionKey.includes('accessory'))
    }
}
